// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
body {
  margin: 0px;
  font-family: 'Lato';
  background: #f1fafb;
  position: relative;
}

p {
  margin: 0px;
}
ul,
ol {
  padding: 0px;
  list-style: none;
  margin: 0px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
}
a {
  text-decoration: none;
  display: inline-block;
}
span,
strong {
  display: inline-block;
}

/* Hide spinners in Chrome, Safari, Edge, Opera */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide spinners in Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;AAC5B","sourcesContent":["* {\n  box-sizing: border-box;\n}\nbody {\n  margin: 0px;\n  font-family: 'Lato';\n  background: #f1fafb;\n  position: relative;\n}\n\np {\n  margin: 0px;\n}\nul,\nol {\n  padding: 0px;\n  list-style: none;\n  margin: 0px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0px;\n}\na {\n  text-decoration: none;\n  display: inline-block;\n}\nspan,\nstrong {\n  display: inline-block;\n}\n\n/* Hide spinners in Chrome, Safari, Edge, Opera */\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide spinners in Firefox */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
